import React from 'react';
import { motion } from 'framer-motion';
import { CATEGORIES, Category } from '../data/startups';
interface CategoryFilterProps {
  activeCategory: Category;
  setActiveCategory: (category: Category) => void;
}
export function CategoryFilter({
  activeCategory,
  setActiveCategory
}: CategoryFilterProps) {
  return <div className="sticky top-16 z-40 w-full border-b border-neutral-200 bg-white/80 backdrop-blur-md" data-id="element-10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="flex items-center overflow-x-auto py-4 scrollbar-hide" data-id="element-12">
          <div className="flex gap-2" data-id="element-13">
            {CATEGORIES.map(category => {
            const isActive = activeCategory === category;
            return <button key={category} onClick={() => setActiveCategory(category)} className={`relative whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors focus:outline-none ${isActive ? 'text-white' : 'text-neutral-600 hover:text-neutral-900 bg-neutral-50 border border-neutral-200 hover:border-neutral-300'}`} data-id="element-14">
                  {isActive && <motion.div layoutId="activeCategoryIndicator" className="absolute inset-0 rounded-full bg-black" initial={false} transition={{
                type: 'spring',
                stiffness: 500,
                damping: 30
              }} data-id="element-15" />}
                  <span className="relative z-10" data-id="element-16">{category}</span>
                </button>;
          })}
          </div>
        </div>
      </div>
    </div>;
}